import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '*',
  component: () => import('@/views/404'),
},
{
  path: '/404',
  component: () => import('@/views/404'),
  hidden: true
},
{
  path: '/',
  component: Layout,
  redirect: '/login',
},
{
  path: '/home',
  component: Layout,
  redirect: '/home/homePage',
  name: 'home',
  meta: {
    title: '首页',
    icon: 'home'
  },
  children: [{
    path: 'index',
    name: 'index',
    component: () => import('@/views/home/homePage/index'),
    meta: {
      title: '首页',
      icon: 'product-list'
    },
  },]
},
{
  path: '/auth',
  component: Layout,
  redirect: '/auth/users',
  name: '权限管理',
  meta: {
    title: '权限管理',
    icon: 'order'
  },
  children: [{
    path: 'users',
    name: '管理员列表',
    component: () => import(`@/views/authManager/authUsers`),
    meta: {
      title: '管理员列表',
      icon: 'product-list'
    },
  },
  {
    path: 'config',
    name: '权限分配',
    component: () => import(`@/views/authManager/authConfig`),
    meta: {
      title: '权限分配',
      icon: 'product-list'
    },
  },
  ]
},
// 供应链管理中心
{
  path: '/supplyChain',
  component: Layout,
  // redirect: '/supplyChain',
  name: 'pharmacyManagement',
  meta: {
    title: '供应链管理中心',
    icon: 'order'
  },
  children: [{
    path: '/supplyChain/pharmacyManagement',
    name: 'pharmacyManagement',
    component: () => import('@/views/supplyChain/pharmacyManagement/pharmacyManagement'),
    meta: {
      title: '合作药厂/药房管理',
      icon: 'product-list'
    },
  },
  {
          path: '/supplyChain/pharmacyDetail',
          name: 'pharmacyDetail',
          component: () => import('@/views/supplyChain/pharmacyManagement/pharmacyDetail'),
          meta: {
            title: '合作药厂/药房管理详情',
            icon: 'product-list'
          },
        },
  {
    path: '/supplyChain/drugManagement',
    name: 'drugManagement',
    component: () => import('@/views/supplyChain/drugManagement/drugManagement'),
    meta: {
      title: '供应链药品管理',
      icon: 'product-list'
    },
  },
  {
          path: '/supplyChain/drugDetail',
          name: 'drugDetail',
          component: () => import('@/views/supplyChain/drugManagement/drugDetail'),
          meta: {
            title: '新增供应链药品',
            icon: 'product-list'
          },
  },
  {
    path: '/supplyChain/updateDrugDetail',
      name: 'updateDrugDetail',
    component: () => import('@/views/supplyChain/drugManagement/updateDrugDetail'),
    meta: {
    title: '修改供应链药品',
      icon: 'product-list'
    },
  },
  {
    path: '/supplyChain/prescriptionManagement',
    name: 'prescriptionManagement',
    component: () => import('@/views/supplyChain/prescriptionManagement/prescriptionManagement'),
    meta: {
      title: '供应链处方管理',
      icon: 'product-list'
    },
  },
  {
    path: '/supplyChain/detail',
    name: 'detail',
    component: () => import('@/views/supplyChain/prescriptionManagement/prescriptionDetail'),
    meta: {
      title: '供应链处方详情',
      icon: 'product-list'
    },
  },
    {
      path: '/supplyChain/prescriptionManagementHangu',
      name: 'prescriptionManagementHangu',
      component: () => import('@/views/supplyChain/prescriptionManagementHangu/prescriptionManagement'),
      meta: {
        title: '汉沽处方运维管理',
        icon: 'product-list'
      },
    },
    {
      path: '/supplyChain/detailHangu',
      name: 'detailHangu',
      component: () => import('@/views/supplyChain/prescriptionManagementHangu/prescriptionDetail'),
      meta: {
        title: '汉沽运维处方详情',
        icon: 'product-list'
      },
    },

  {
    path: '/supplyChain/drugOrder',
    name: 'drugOrder',
    component: () => import('@/views/supplyChain/drugOrder/drugOrder'),
    meta: {
      title: '供应链药品订单',
      icon: 'product-list'
    },
  },

  {
          path: '/supplyChain/drugOrderDetail',
          name: 'drugOrderDetail',
          component: () => import('@/views/supplyChain/drugOrder/drugOrderDetail'),
          meta: {
            title: '供应链药品订单详情',
            icon: 'product-list'
          },
  },


  {
    path: '/supplyChain/agreement',
    name: 'agreement',
    component: () => import('@/views/supplyChain/agreement/agreementList'),
    meta: {
      title: '供应链协定方管理',
      icon: 'product-list'
    },
  },
  {
          path: '/supplyChain/agreementDetail',
          name: 'drugOrderDetail',
          component: () => import('@/views/supplyChain/agreement/agreementDetail'),
          meta: {
            title: '供应链协定方管理详情',
            icon: 'product-list'
          },
  },

  {
    path: '/supplyChain/pharmacistAccount',
    name: 'pharmacistAccount',
    component: () => import('@/views/supplyChain/pharmacistAccount/pharmacistAccount'),
    meta: {
      title: '供应链药师账号管理',
      icon: 'product-list'
    },
  },{
    path: '/supplyChain/surcharge',
    name: 'surcharge',
    component: () => import('@/views/supplyChain/surcharge/surcharge'),
    meta: {
      title: '供应链附加费用管理',
      icon: 'product-list'
    },
  },{
    path: '/supplyChain/packaging',
    name: 'packaging',
    component: () => import('@/views/supplyChain/packaging/packaging'),
    meta: {
      title: '管理药厂药品包装配置',
      icon: 'product-list'
    },
  },{
    path: '/supplyChain/prescriptionList',
    name: 'prescriptionList',
    component: () => import('@/views/prescriptionList/prescriptionList'),
    meta: {
      title: '方案列表',
      icon: 'product-list'
    },
  },{
      path: '/supplyChain/agreementUtil',
      name: 'agreementUtil',
      component: () => import('@/views/supplyChain/agreementUtil/agreementUtil'),
      meta: {
        title: '协定方工具',
        icon: 'product-list'
      }
   },{
      path: '/supplyChain/salesVolume',
      name: 'salesVolume',
      component: () => import('@/views/supplyChain/drugManagement/salesVolume'),
      meta: {
        title: 'testPush',
        icon: 'product-list'
      }
    }
  ]
},
{
  path: '/forgotpassword',
  component: Layout,
  redirect: '/forgotpassword',
  name: 'forgotpassword',
  meta: { title: 'FORGOTPASSWORD', icon: 'order' },
  children: [
    {
      path: 'forgotpasswords',
      name: 'forgotpasswords',
      component: () => import('@/views/forgotpassword/forgotpasswords'),
      meta: { title: '忘记密码', icon: 'product-list' },
    }
  ]
},
{
  path: '/weChatPublic',
  component: Layout,
  redirect: '/weChatPublic',
  name: 'takeCashApplication',
  meta: {
    title: '公众号管理',
    icon: 'order'
  },
  children: [{
    path: 'publciTogethe',
    name: 'publciTogethe',
    component: () => import('@/views/weChatPublic/publciTogethe'),
    meta: {
      title: '合作医生管理',
      icon: 'product-list'
    },
  }, {
    path: 'userPublicList',
    name: 'userPublicList',
    component: () => import('@/views/weChatPublic/userPublicList'),
    meta: {
      title: '关注用户管理',
      icon: 'product-list'
    },
  },{
    path: 'publcTogetheDetail',
    name: 'publcTogetheDetail',
    component: () => import('@/views/weChatPublic/publcTogetheDetail'),
    meta: {
      title: '合作医生详情',
      icon: 'product-list'
    },
  },{
    path: 'userPublicDetail',
    name: 'userPublicDetail',
    component: () => import('@/views/weChatPublic/userPublicDetail'),
    meta: {
      title: '关注用户详情',
      icon: 'product-list'
    },
  } ]
},

{
  path: '/financeCenter',
  component: Layout,
  redirect: '/financeCenter/takeCashApplication',
  name: 'takeCashApplication',
  meta: {
    title: '财务管理中心',
    icon: 'order'
  },
  children: [{
    path: 'dividedIntoManagement',
    name: 'dividedIntoManagement',
    component: () => import('@/views/financeCenter/dividedIntoManagement/dividedIntoManagement'),
    meta: {
      title: '分成设置管理',
      icon: 'product-list'
    },
  }, {
    path: 'addedInto',
    name: 'addedInto',
    component: () => import('@/views/financeCenter/dividedIntoManagement/addedInto'),
    meta: {
      title: '分成设置',
      icon: 'product-list'
    },
  }, {
    path: 'intoStatistics',
    name: 'intoStatistics',
    component: () => import('@/views/financeCenter/intoStatistics/intoStatistics'),
    meta: {
      title: '分成统计',
      icon: 'product-list'
    },
  },
    {
      path: 'salesStatistics',
      name: 'salesStatistics',
      component: () => import('@/views/financeCenter/salesStatistics/salesStatistics'),
      meta: {
        title: '分成收费统计',
        icon: 'product-list'
      },
     },
    {
      path: 'prescriptionDetails',
      name: 'prescriptionDetails',
      component: () => import('@/views/financeCenter/salesStatistics/prescriptionDetails'),
      meta: {
        title: '处方详情',
        icon: 'product-list'
      },
    },
  ]
},{
  path: '/pharmacy',
  component: Layout,
  redirect: '/pharmacy/pharmacyList',
  name: 'pharmacy',
  meta: {
    title: '云HIS管理中心',
    icon: 'order'
  },
  children: [{
    path: 'pharmacyList',
    name: 'pharmacyList',
    component: () => import('@/views/pharmacyDistribution/pharmacyList'),
    meta: {
      title: '云药房分配',
      icon: 'product-list'
    }
  },{
    path: 'pharmacyDetail',
    name: 'pharmacyDetail',
    component: () => import('@/views/pharmacyDistribution/pharmacyDetail'),
    meta: {
      title: '云药房详情',
      icon: 'product-list'
    }
  }]
},{
  path: '/needlePusher',
  component: Layout,
  redirect: '/needlePusher/needlePusher',
  name: 'needlePusher',
  meta: {
    title: '针推师账号管理',
    icon: 'order'
  },
  children: [{
    path: 'management',
    name: 'AccountManagement',
    component: () => import('@/views/needlePusher/needlePusher'),
    meta: {
      title: '针推师账号管理',
      icon: 'product-list'
    }
  }]
},{
  path: '/integration',
  component: Layout,
  redirect: '/integration/integration',
  name: 'integration',
  meta: {
    title: '三层一体审核管理',
    icon: 'order'
  },
  children: [{
    path: 'management',
    name: 'AccountManagement',
    component: () => import('@/views/auditManagement/contractingParty'),
    meta: {
      title: '协定方管理',
      icon: 'product-list'
    }
  },{
    path: 'treat',
    name: 'treat',
    component: () => import('@/views/auditManagement/treatmentManagement'),
    meta: {
      title: '治疗管理',
      icon: 'product-list'
    },
  },{
    path: 'cooperativeTherapy',
    name: 'treat',
    component: () => import('@/views/auditManagement/cooperativeTherapy'),
    meta: {
      title: '合作治疗发送方案',
      icon: 'product-list'
    },
  },{
    path: 'consumables',
    name: 'consumables',
    component: () => import('@/views/auditManagement/treatmentConsumables'),
    meta: {
      title: '治疗耗材',
      icon: 'product-list'
    },
  },]
},


{
  path: '*',
  redirect: '/404',
  hidden: true
}
]
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap,

})



// WEBPACK FOOTER //
// ./src/router/index.js